import React from 'react';
import '../styles/Metrics.css';

const Metrics = () => {
  return (
    <div className="metrics-container">
      <div className="metric-item">
        <div className="metric-value">5+</div>
        <div className="metric-label">Years Experience</div>
      </div>
      <div className="metric-separator"></div>
      <div className="metric-item">
        <div className="metric-value">500+</div>
        <div className="metric-label">Artists Supported</div>
      </div>
      <div className="metric-separator"></div>
      <div className="metric-item">
        <div className="metric-value">99%</div>
        <div className="metric-label">Satisfaction Rate</div>
      </div>
      <div className="metric-separator"></div>
      <div className="metric-item">
        <div className="metric-value">$4.99</div>
        <div className="metric-label">Starting At</div>
      </div>
    </div>
  );
};

export default Metrics;
